import { ROLES as R } from "../core/roles";
import { everyoneBut, lud, rule } from "../core/rule";

export const guidelinePermissions = {
  view: "guideline.view",
  nav: "guideline.nav",
  video: { manage: "guideline.video.manage" },
  section: { branchOnly: "guideline.section.branchOnly" },
};

export const guidelineGrants = {
  "guideline.view": rule([...everyoneBut(), R.NEW]),
  "guideline.nav": rule(lud(R.BRANCH, R.FA, R.MENU_SP, R.DM, R.DMM, R.AM, R.SALES, R.STORE_L, R.STORE, R.NEW)),
  "guideline.video.manage": rule(lud(R.DMM, R.AM)),
  // branch users get a shorter list of sections.
  "guideline.section.branchOnly": rule([R.BRANCH]),
};
